<template>
  <AppMembersSelector
    ref="members-user-selector"
    :organization-id="organizationId"
    :resource="resource"
    :records="['members', 'teams']"
    :changed-items="changedItems"
    :select-all-items="selectAllItems"
    multiple
    sortable
    show-select-all-trigger
    @submit-selections="selectMember"
  >
    <template #title>
      <label class="control-label">Members</label>
    </template>
  </AppMembersSelector>
</template>

<script>
import { TimesheetsResource } from '~/resources';

export default {
  name: 'TimesheetsMemberSelector',
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
    dateEnd: {
      type: String,
      required: false,
    },
    status: {
      type: String,
      required: false,
    },
    users: {
      type: Array,
      required: false,
    },
    selectAll: {
      type: Object,
      required: false,
    },
  },
  computed: {
    resource() {
      return TimesheetsResource;
    },
    changedItems() {
      const teams = [];
      const members = [];

      this.users?.forEach((id) => {
        if (id.includes('team:')) {
          teams.push({ id: parseInt(id.match(/\d+/)[0]), selected: !this.selectAll?.teams });
        } else {
          members.push({ id: parseInt(id), selected: !this.selectAll?.members });
        }
      });

      return {
        teams,
        members,
      };
    },
    selectAllItems() {
      return {
        members: this.selectAll?.members === 'true',
        teams: this.selectAll?.teams === 'true',
      };
    },
  },
  methods: {
    selectMember(data) {
      const params = { date: this.date, date_end: this.dateEnd, 'filters[status]': this.status };
      const cleanedParams = Object.fromEntries(
        Object.entries(params).filter(([, value]) => !['', null, undefined].includes(value)),
      );
      const queryString = new URLSearchParams(cleanedParams);
      const notSelectAll = !data.options.select_all.members && !data.options.select_all.teams;

      data.items.members.forEach((member) => {
        if ((notSelectAll && member.selected) || (!notSelectAll && !member.selected)) {
          queryString.append('filters[users][]', member.user_id);
        }
      });

      data.items.teams.forEach((member) => {
        if ((notSelectAll && member.selected) || (!notSelectAll && !member.selected)) {
          queryString.append('filters[users][]', `team:${member.user_id}`);
        }
      });

      Object.entries(data.options.select_all).forEach(([key, value]) => {
        if (value) {
          queryString.append(`filters[select_all][${key}]`, value);
        }
      });

      window.location.href = queryString.size ? new URL(this.url) + `?${queryString}` : new URL(this.url);
    },
  },
};
</script>
